export const ARROW_DOWN = "/images/arrow_down.svg";
